/* eslint-disable max-len */
const ReadIcon = () => (
  <svg
    aria-hidden
    height='36'
    version='1.1'
    viewBox='-15 -20 60 100'
    width='36'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fillRule='evenodd' id='Page-1' stroke='none' strokeWidth='1'>
      <g id='Bookshelf-Icon'>
        <g id='Page-1'>
          <g id='Bookshelf-Icon'>
            <g id='icon-white-editable-bookshelf'>
              <path d='M20,10 L20,0 L0,10 L0,50 L30,50 L30,10 L20,10 L20,10 L20,10 Z M14.8,29.6 C14.8,30.1 14.5,30.3 14.1,29.9 L12,27.5 C11.6,27.1 11,27.1 10.6,27.5 L8.5,29.8 C8.1,30.2 7.8,30.1 7.8,29.5 L7.8,10 L14.8,10 L14.8,29.6 L14.8,29.6 L14.8,29.6 Z' id='Shape' />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default ReadIcon
